import { createContext } from "react";
import { ResultsMenuCategory } from "@data-types/results";

export const ResultsMenuCategoryContext = createContext(
	{} as ResultsMenuCategory
);
